/* @flow */
import React from 'react';

import THead from 'components/UIKit/Table/THead';
import Tr from 'components/UIKit/Table/Tr';
import Th from 'components/UIKit/Table/Th';

type AnnotationsColumnsProps = {
  router: Object,
  order: string,
  sort: string
}

export default function AnnotationsColumns({
  router, sort, order
}: AnnotationsColumnsProps): React.Element {
  return (
    <THead>
      <Tr>
        <Th sort={sort} order={order} sortable field="submitter_id" style={{paddingLeft: '2.8rem'}}>Submitter ID</Th>
        <Th sort={sort} order={order} sortable field="category">Category</Th>
        <Th>Entity Type</Th>
        <Th>Entity Submitter ID</Th>
        <Th sort={sort} order={order} sortable field="updated_datetime">Last Updated</Th>
      </Tr>
    </THead>
  );
}
